import { versionItems } from "@/mocks/homeData";

export default function Versions() {
  return (
    <section id="versions" className="w-full scroll-mt-20 bg-background-100 py-16 md:py-24">
      <div className="mx-auto grid w-full max-w-6xl grid-cols-1 gap-10 px-4 md:px-6 lg:grid-cols-12 lg:gap-14">
        <div className="lg:col-span-4">
          <span className="text-xs font-semibold tracking-[0.2em] text-accent-700">VERSIONS / 版本说明</span>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            版本与画质说明
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            “全集”“未删减版”“高清”“多语字幕”……这些词在搜索结果里高频出现，但含义并不总是你理解的那样。
            先弄清它们分别指什么，能帮你避开不少坑。
          </p>

          <div className="mt-6 rounded-xl border border-primary-200 bg-primary-50 p-5">
            <p className="flex gap-3 text-sm leading-relaxed text-primary-900">
              <i className="ri-alert-line mt-0.5 shrink-0 text-lg"></i>
              <span>
                来源不同的版本可能在时长、剪辑顺序上存在差异，观看前不妨先核对官方公布的集数与时长。
              </span>
            </p>
          </div>
        </div>

        <ul className="space-y-4 lg:col-span-8">
          {versionItems.map((item) => (
            <li
              key={item.title}
              className="flex gap-4 rounded-xl border border-background-200 bg-background-50 p-5 md:p-6"
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-800">
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <div>
                <h3 className="font-heading text-base font-bold text-foreground-950">{item.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}